import endpoint from "../Constant/endpoint";
import { updateValues } from "./authAction";
import services from "../Constant/service";
import { showErrorSnackbar, showSuccessSnackbar } from "./snackbarAction";

export const upcomingInterview = (data, callback, errorCallback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.postApiCall(
    endpoint.studentInterview.upcomingInterview,
    data,
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.statusCode === services?.status_code?.success) {
        dispatch(showSuccessSnackbar(res?.msg));
        callback(res);
      } else {
        errorCallback(res);
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg)
      );
      dispatch(updateValues("loader", false));
      errorCallback(error);
    }
  );
};

export const googleAuthAPI = (callback) => async (dispatch) => {
  dispatch(updateValues("loader", true));
  services.getApiCall(
    "/v1/admin/auth/google",
    "",
    (res) => {
      dispatch(updateValues("loader", false));
      if (res?.data?.statusCode === services?.status_code?.success) {
        dispatch(showSuccessSnackbar(res?.data?.msg));
        callback(res?.data?.data);
      } else {
        dispatch(showErrorSnackbar(res?.msg));
      }
    },
    (error) => {
      dispatch(
        showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg)
      );
      dispatch(updateValues("loader", false));
    }
  );
};

  export const updateUpcomingInterviewStatus =
    (data, id, callback) => async (dispatch) => {
      dispatch(updateValues("loader", true));
      services.patchApiCall(
        endpoint.studentInterview.updateUpcomingInterviewStatus + id,
        data,
        (res) => {
          dispatch(updateValues("loader", false));
          if (res?.data?.statusCode === services?.status_code?.success) {
            dispatch(showSuccessSnackbar(res?.data?.msg));
            callback(res?.data.data);
          } else {
            dispatch(showErrorSnackbar(res?.data?.msg));
          }
        },
        (error) => {
          dispatch(
            showErrorSnackbar(error?.data?.msg ? error?.data?.msg : error?.msg),
          );
          dispatch(updateValues("loader", false));
        },
      );
    };